import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import CaseList from './CaseList';
import CasePage from './Case';

const useStyles = makeStyles({
  panel: {
    width: '100%',
  },
  hidden: {
    display: 'none',
  },
});

/**
 * Keeps the case list and last-opened case page mounted so navigation
 * back to the same case is instant. When opening a different case, the
 * route id is used immediately so stale case content is not shown.
 */
export default function MainWorkspace({ id: caseId }) {
  const classes = useStyles();
  const location = useLocation();
  const isCaseRoute = location.pathname.startsWith('/case/');
  const activeCaseId = isCaseRoute ? caseId : null;
  const [cachedCaseId, setCachedCaseId] = useState(null);

  useEffect(() => {
    if (activeCaseId) {
      setCachedCaseId(activeCaseId);
    }
  }, [activeCaseId]);

  const displayCaseId = isCaseRoute ? activeCaseId : cachedCaseId;

  return (
    <>
      <div className={isCaseRoute ? classes.hidden : classes.panel}>
        <CaseList />
      </div>
      {displayCaseId && (
        <div className={isCaseRoute ? classes.panel : classes.hidden}>
          <CasePage key={displayCaseId} id={displayCaseId} />
        </div>
      )}
    </>
  );
}
